import { render } from "./About.vue?vue&type=template&id=1219db8c"
const script = {}
script.render = render

export default script